
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!wiki.wiki_page_edit";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'wiki/WikiPageEdit';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.content_is_locked), {hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <h1>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h1>\n        <input name=\"title\" type=\"hidden\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n      ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <label for=\"title\" class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "title_label", "Page Title", options) : helperMissing.call(depth0, "t", "title_label", "Page Title", options)))
    + "</label>\n        <input id=\"title\" name=\"title\" type=\"text\" class=\"span4 title\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" maxlength=\"255\" autofocus>\n      ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <h2>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h2>\n    ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.use_rce_enhancements), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program9(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <div class=\"switch_views_container\">\n          <div class=\"help_dialog\"></div>\n          <a href=\"#\" class=\"switch_views\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "#editor.switch_editor_html", "HTML Editor", options) : helperMissing.call(depth0, "t", "#editor.switch_editor_html", "HTML Editor", options)))
    + "\n          </a>\n          <a href=\"#\" class=\"switch_views\" style=\"display:none;\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "#editor.switch_editor_rich_text", "Rich Content Editor", options) : helperMissing.call(depth0, "t", "#editor.switch_editor_rich_text", "Rich Content Editor", options)))
    + "\n          </a>\n        </div>\n      ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    ";
  if (helper = helpers.body) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.body); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <label for=\"wiki_page_body\" class=\"hidden-readable\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "raw_html_editor_e3993e41", "Raw HTML Editor", options) : helperMissing.call(depth0, "t", "raw_html_editor_e3993e41", "Raw HTML Editor", options)))
    + "</label>\n    <textarea id=\"wiki_page_body\" rows=\"20\" cols=\"40\" name=\"body\" class=\"body\" aria-hidden=\"true\"";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.PAGE_RIGHTS)),stack1 == null || stack1 === false ? stack1 : stack1.update), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{
    'forEditing': (1)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.body), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.body), options)))
    + "</textarea>\n  ";
  return buffer;
  }
function program14(depth0,data) {
  
  
  return " autofocus";
  }

function program16(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"responsive-control-group options\">\n      <label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "options_label", "Options", options) : helperMissing.call(depth0, "t", "options_label", "Options", options)))
    + "</strong></label>\n      <div class=\"controls\">\n        <label id=\"editing_roles_label\"  for=\"editing_roles\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "Can edit this page role selection", options) : helperMissing.call(depth0, "t", "Can edit this page role selection", options)))
    + "</label>\n        <select id=\"editing_roles\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "Can edit this page role selection", options) : helperMissing.call(depth0, "t", "Can edit this page role selection", options)))
    + "\" name=\"editing_roles\" class=\"responsive-width\">\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.SHOW)),stack1 == null || stack1 === false ? stack1 : stack1.COURSE_ROLES), {hash:{},inverse:self.program(20, program20, data),fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </select>\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CAN_SET_TODO_DATE), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CONDITIONAL_RELEASE_SERVICE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n  ";
  return buffer;
  }
function program17(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <option value=\"teachers\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.TEACHER_ROLE), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "course_editing_roles.only_teachers", "Only teachers", options) : helperMissing.call(depth0, "t", "course_editing_roles.only_teachers", "Only teachers", options)))
    + "</option>\n            <option value=\"teachers,students\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.STUDENT_ROLE), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "course_editing_roles.teachers_and_students", "Teachers and students", options) : helperMissing.call(depth0, "t", "course_editing_roles.teachers_and_students", "Teachers and students", options)))
    + "</option>\n            <option value=\"teachers,students,public\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.ANYONE_ROLE), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "course_editing_roles.anyone", "Anyone", options) : helperMissing.call(depth0, "t", "course_editing_roles.anyone", "Anyone", options)))
    + "</option>\n          ";
  return buffer;
  }
function program18(depth0,data) {
  
  
  return " selected";
  }

function program20(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <option value=\"members\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.MEMBER_ROLE), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "editing_roles.only_members", "Only members", options) : helperMissing.call(depth0, "t", "editing_roles.only_members", "Only members", options)))
    + "</option>\n            <option value=\"members,public\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.ANYONE_ROLE), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "editing_roles.anyone", "Anyone", options) : helperMissing.call(depth0, "t", "editing_roles.anyone", "Anyone", options)))
    + "</option>\n          ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div class=\"controls-section\">\n            <label for=\"student_planner_checkbox\" class=\"checkbox\">\n            <input value=\"1\" type=\"checkbox\" id=\"student_planner_checkbox\" name=\"student_planner_checkbox\" "
    + escapeExpression((helper = helpers.checkedIf || (depth0 && depth0.checkedIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_date), options) : helperMissing.call(depth0, "checkedIf", (depth0 && depth0.todo_date), options)))
    + " />\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "add_to_student_to_do_58e66b4b", "Add to student to-do", options) : helperMissing.call(depth0, "t", "add_to_student_to_do_58e66b4b", "Add to student to-do", options)))
    + "\n            </label>\n            <div id=\"todo_date_container\" />\n          </div>\n        ";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div class=\"controls-section\">\n            <label class=\"checkbox\" for=\"conditional_content\">\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("conditional_content"),
    'class': ("element_toggler"),
    'checked': ((depth0 && depth0.set_assignment))
  },data:data},helper ? helper.call(depth0, "assignment.set_assignment", options) : helperMissing.call(depth0, "checkbox", "assignment.set_assignment", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "allow_in_mastery_paths_5332c786", "Allow in mastery paths", options) : helperMissing.call(depth0, "t", "allow_in_mastery_paths_5332c786", "Allow in mastery paths", options)))
    + "\n            </label>\n          </div>\n        ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <button class=\"btn btn-default save_and_publish\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "buttons.save_and_publish", "Save & Publish", options) : helperMissing.call(depth0, "t", "buttons.save_and_publish", "Save & Publish", options)))
    + "</button>\n      ";
  return buffer;
  }

  buffer += "<div class=\"edit-content\">\n  <div class=\"edit-header\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.EDIT_TITLE), {hash:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.content_is_locked), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.content_is_locked), {hash:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.EDIT_ROLES), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<div class=\"form-actions clearfix\">\n  <div>\n    <label for=\"notify_of_update\" class=\"checkbox clearfix pull-left\" style=\"margin-top:5px\">\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "notify_of_update", options) : helperMissing.call(depth0, "checkbox", "notify_of_update", options)))
    + "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "notify_users_text", "Notify users that this content has changed", options) : helperMissing.call(depth0, "t", "notify_users_text", "Notify users that this content has changed", options)))
    + "\n    </label>\n    <div class=\"page-edit__action_buttons\">\n      <button class=\"btn cancel\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "buttons.cancel", "Cancel", options)))
    + "</button>\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH_NOW), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <button class=\"btn btn-primary submit\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "buttons.save", "Save", options) : helperMissing.call(depth0, "t", "buttons.save", "Save", options)))
    + "</button>\n    </div>\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  